/** Official App Store / Google Play badges — same artwork as website/src/app/download. */
export default function StoreBadges() {
  return (
    <div className="flex items-center justify-center gap-3">
      <a
        href="https://apps.apple.com/app/id6757656390"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2.5 rounded-xl bg-black px-4 py-2 text-white transition hover:bg-black/80"
      >
        <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
        </svg>
        <span className="text-left">
          <span className="block text-[9px] leading-tight">Download on the</span>
          <span className="block text-sm font-semibold leading-tight">App Store</span>
        </span>
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.covenantlabs.flock"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2.5 rounded-xl bg-black px-4 py-2 text-white transition hover:bg-black/80"
      >
        <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path d="M3.61 1.814L13.793 12 3.61 22.186a1.12 1.12 0 01-.61-.995V2.81c0-.415.226-.776.61-.995z" fill="#4285F4" />
          <path d="M17.04 8.72L13.793 12l3.247 3.28 3.666-2.12c.63-.36.63-1.26 0-1.62L17.04 8.72z" fill="#FBBC04" />
          <path d="M3.61 1.814L13.793 12l3.247-3.28L5.84.467A1.12 1.12 0 003.61 1.814z" fill="#34A853" />
          <path d="M13.793 12L3.61 22.186A1.12 1.12 0 005.84 23.533l11.2-6.253L13.793 12z" fill="#EA4335" />
        </svg>
        <span className="text-left">
          <span className="block text-[9px] uppercase leading-tight">Get it on</span>
          <span className="block text-sm font-semibold leading-tight">Google Play</span>
        </span>
      </a>
    </div>
  );
}
